// 261029 S4 — khối gấp «Prompt đã gửi» (chữ NGUYÊN VĂN `clip.prompt`) + nút «Sao chép». MỘT chỗ vẽ cho màn chính (WorkflowPromptVideoStep) và ngăn chi tiết (WorkflowVideoStep);
// việc sao chép đi qua `copyTextToClipboard` (thuần, có test).
import React from 'react';
import { Button, message } from 'antd';
import { copyTextToClipboard } from './copyText';

interface Props { prompt: string; /** Tiền tố data-testid (mặc định `wf-clip`). */ testIdPrefix?: string }

const ClipPromptFold: React.FC<Props> = ({ prompt, testIdPrefix = 'wf-clip' }) => {
  const copy = async () => {
    if (await copyTextToClipboard(prompt)) message.success('Đã sao chép prompt');
    else message.error('Không sao chép được — chọn chữ rồi nhấn Ctrl+C');
  };
  return (
    <details style={{ marginTop: 6 }} data-testid={`${testIdPrefix}-prompt`}>
      <summary style={{ cursor: 'pointer', fontSize: 12 }}>Prompt đã gửi</summary>
      <div style={{ maxHeight: 320, overflow: 'auto', whiteSpace: 'pre-wrap', fontSize: 12, margin: '6px 0' }} data-testid={`${testIdPrefix}-prompt-text`}>{prompt}</div>
      <Button size="small" onClick={() => { void copy(); }} data-testid={`${testIdPrefix}-prompt-copy`}>Sao chép</Button>
    </details>
  );
};

export default ClipPromptFold;
